import { Button, Modal, ModalActions, ModalContent, ModalTitle } from '@ifs-gcp/components';

import styles from './modals.module.scss';

interface DocumentDeleteModalProps {
  typeName: string;
  fileName: string;
  translations: Record<string, string>;
  onDelete: () => void;
  onClose: () => void;
}

export const DocumentDeleteModal = ({
  typeName,
  fileName,
  translations,
  onDelete,
  onClose,
}: DocumentDeleteModalProps) => {
  return (
    <Modal className={styles.modal} open onClose={onClose}>
      <ModalTitle className={styles.modalTitle} onClose={onClose}>
        {translations.delete}: {typeName}
      </ModalTitle>

      <ModalContent className={styles.deleteContent}>
        <span className={styles.question}>{translations.deleteConfirmation}</span>
        <span className={styles.fileName}>{fileName}</span>
      </ModalContent>

      <ModalActions>
        <Button variant="text" onClick={onClose}>
          {translations.close}
        </Button>
        <Button variant="contained" color="error" onClick={onDelete}>
          {translations.delete}
        </Button>
      </ModalActions>
    </Modal>
  );
};
